(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/track/telephone/deleteConfirm.tpl.html',
    '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" translate="deleteConfirm.delete_title"></h3></div><div class="modal-body"><div style="margin-top: 5px" class="input-group"><p translate="deleteConfirm.delete_body"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="delete()" translate="deleteConfirm.delete_button"></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="close()" translate="deleteConfirm.cancel_button"></button></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/deleteConfirm.tpl.js